/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2017, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

export const TextArea = React.forwardRef(({ id, label, title, placeholder, value, style, rows, onChange, autoFocus, disabled, className }, ref) => {
  let textAreaId = id || `textarea_${Math.floor(Math.random() * 1000)}`

  if (disabled) {
    style = { ...style, ...{ resize: 'none' } }
  }

  return (
    <div className={`slds-form-element ${className || ''}`}>
      {label &&
        <label
          className="slds-form-element__label"
          htmlFor={textAreaId}>
          {label}
        </label>
      }
      <div className="slds-form-element__control">
        <textarea
          ref={ref}
          id={textAreaId}
          title={title}
          className="slds-textarea"
          placeholder={placeholder}
          value={value}
          style={style}
          rows={rows}
          onChange={onChange}
          autoFocus={autoFocus}
          disabled={disabled}
        />
      </div>
    </div>
  )
})

TextArea.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  style: PropTypes.object,
  rows: PropTypes.number,
  onChange: PropTypes.func,
  autoFocus: PropTypes.bool,
  title: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/text-area/index.js